import { Badge } from "@/components/ui/badge";

export const ParentCommunicationHero = ({ organizationName, heroImageUrl }) => {
  return (
    <section
      className="relative overflow-hidden rounded-[2rem] border border-white/70 shadow-2xl"
      data-testid="parent-communication-hero"
    >
      <div className="absolute inset-0">
        <img
          src={heroImageUrl}
          alt="Parent and childcare staff communicating in the classroom"
          className="h-full w-full object-cover"
          data-testid="parent-communication-hero-image"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0c5b5a]/90 via-[#106c86]/75 to-[#f28c28]/45" />
      <div className="relative grid gap-6 px-6 py-8 sm:px-8 lg:grid-cols-[1.2fr_0.8fr] lg:px-10 lg:py-10">
        <div className="max-w-2xl space-y-5 text-white">
          <div className="flex flex-wrap items-center gap-3">
            <img
              src="/simple-sign-in-logo.png"
              alt="ToDays Kidz Simple Sign-In"
              className="h-14 w-14 rounded-2xl bg-white/95 p-2 shadow-lg"
              data-testid="parent-communication-logo"
            />
          </div>
          <div className="space-y-3">
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-white/80" data-testid="parent-communication-eyebrow">
              Settings / Parent Communication
            </p>
            <h2 className="text-4xl font-bold leading-tight sm:text-5xl" data-testid="parent-communication-hero-title">
              Give families a bright, mobile-ready window into daily care.
            </h2>
            <p className="max-w-xl text-sm text-white/90 sm:text-base" data-testid="parent-communication-hero-description">
              {organizationName || "Your center"} can invite parents into a controlled experience for updates,
              messaging, documents, billing, and announcements — while keeping staff-only operations private.
            </p>
          </div>
        </div>

        <div className="self-end justify-self-start rounded-[1.75rem] border border-white/30 bg-white/18 p-5 text-white backdrop-blur-md lg:justify-self-end">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-white/80" data-testid="parent-communication-revenue-label">
            Center add-on
          </p>
          <p className="mt-3 text-3xl font-bold" data-testid="parent-communication-revenue-price">$24.99/mo</p>
          <p className="mt-2 max-w-xs text-sm text-white/90" data-testid="parent-communication-revenue-description">
            Centers activate this add-on first, then choose the child-level fee they want parents to pay after the trial.
          </p>
        </div>
      </div>
    </section>
  );
};
